export default __webpack_public_path__ + "static/media/GilroyWhite.0144749c.svg";